export const VIEW_CATEGORY = 'VIEW_CATEGORY'
export const SET_CATEGORY = 'SET_CATEGORY'